import { SavedSearchCard } from './SavedSearchCard';

import type { ISavedSearch } from '../../../../../api/types/savedSearchApiTypes';

type SavedSearchesProps = {
  savedSearches: Array<ISavedSearch>;
  onClickSavedSearch: () => void;
};

const SavedSearches = (props: SavedSearchesProps) => {
  const { savedSearches, onClickSavedSearch } = props;

  return (
    <ul>
      {savedSearches.map((savedSearch) => {
        return (
          <SavedSearchCard
            key={savedSearch.id}
            savedSearch={savedSearch}
            onClickSavedSearch={onClickSavedSearch}
          />
        );
      })}
    </ul>
  );
};

export { SavedSearches };
